module.exports = __webpack_public_path__ + "static/img/aboutus2.56f4a617.jpg";